export const TASK_CREATE_TOOL_NAME = 'TaskCreate'
